export default {"src":"/_next/static/media/close.06e6e74c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};